import {Shape as ShapeData} from '../../lib/shapes'
import {Shape} from './Shape'
import { REVEAL_FAST_TIME_MS } from '../../constants/settings'

type Props = {
  puzzle: ShapeData[]
  isDarkMode: boolean,
  size?: number
  containerSize?: number,
  isCelebrating?: boolean,
  revealTime?: number
}

export const Puzzle = ({puzzle, isDarkMode, size, containerSize, isCelebrating=false, revealTime=REVEAL_FAST_TIME_MS}: Props) => {
  return (
    <>
    <div className="flex justify-center md:mb-1" role="list" aria-label="puzzle">
      {puzzle.map((s: ShapeData, i: number) => {
        return <Shape
          key={i}
          shape={s}
          size={size}
          position={i}
          containerSize={containerSize}
          useMargin={true}
          isDarkMode={isDarkMode}
          isCelebrating={isCelebrating}
          revealTime={revealTime}
        />
      })}
    </div>
    </>
  )
}
